// extracted by mini-css-extract-plugin
module.exports = {"contactPage":"special_contactPage__3qxdL","contactForm":"special_contactForm__31sZX"};